// Formatadores de moeda em BRL, centralizados para evitar duplicação entre a
// landing, o checkout (PlanCheckout) e as páginas de assinatura/cadastro.
// Os valores chegam do backend em centavos.

export const formatCurrency = (centavos: number): string =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(centavos / 100);

// Versão sem centavos para o preço em destaque (ex.: "R$ 4.000").
export const formatPriceShort = (centavos: number): string =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(centavos / 100);
